import { render } from "./main.vue?vue&type=template&id=817dcac6"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=817dcac6&lang=scss"
import "./main.vue?vue&type=style&index=1&id=817dcac6&lang=scss"

import exportComponent from "/Users/xiaoyin/beai-radar-Enadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__